export default __webpack_public_path__ + "static/media/47-min.11fe6951.png";